import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ToggleMenuService {

  private statusSrc = new BehaviorSubject(false);
  statusChange = this.statusSrc.asObservable();

  changeStatus(status: boolean) {
    console.log('Subscription menu status: ' + status);
    this.statusSrc.next(status);
  }

}
